module.exports = {
  username: 'Benutzername',
  password: 'Kennwort',
  name: 'Name',
  currency: 'Währung',
  status: 'Status',
  actions: 'Aktionen',
  filter: 'Firmenfilter',
  active: 'Aktiv',
  inactive: 'Inaktiv',
  phone: 'Telefonnr.',
  email: 'Email',
  externalID: 'Externe ID',
  testMode: 'Test Modus',
  addressLine: 'Addresszeile',
  locality: 'Lokalität',
  townCity: 'Ort/Stadt',
  country: 'Land',
  postalcode: 'PLZ',
  createCompany: 'Firma erstellen',
  editCompany: 'Firma bearbeiten',
  customOption: 'Kundenoption',
  search: 'Suche',
  export: 'Exportieren',
  available: 'Verfügbar',
  inuse: 'In Verwendung',
  finishing: 'Abschluss',
  reserved: 'Reserviert',
  idle: 'Untätig',
  size: 'Größe',
  style: 'Stil',
  variant: 'Variante',
  options: 'Optionen',
  orderCode: 'Bestellkode',
  source: 'Quelle',
  discount: 'Rabatt',
  discountTotal: 'Rabattbetrag',
  percentDiscount: 'Rabatt %',
  terminals: 'Terminals',
  loadingTerminals: 'Lade Terminals...',
  payments: 'Zahlungen',
  from: 'Von',
  to: 'Bis',
  training: 'Training',
  notes: 'Anmerkungen ...',
  driverNotes: 'Fahrernotizen ...',
  serviceCharges: 'Service Gebühr',
  postalCode: 'PLZ',
  line1: 'Zeile 1',
  line2: 'Zeile 2',
  line3: 'Zeile 3',
  line4: 'Zeile 4',
  action: 'Aktion',
  serviceCharge: 'Servicegebühr',
  deliveryCharge: 'Liefergebühr',
  invoice: 'Rechnung',
  invoiceSearch: 'Rechnungssuche',
  receiptSearch: 'Belegsuche',
  invoiceNumber: 'Rechnungsnr.',
  receiptNo: 'Belegnr.',
  receiptTypes: 'Beleg Typ',
  startReceipt: 'Startbeleg',
  endReceipt: 'Endbeleg',
  monthlyReceipt: 'Monatlicher Beleg',
  yearlyReceipt: 'Jährlicher Beleg',
  nullReceipt: 'Null Beleg',
  regularReceipt: 'Normalbeleg',
  cancelReceipt: 'Stornobeleg',
  collectionReceipt: 'Sammelbeleg',
  allNone: '全部/没有',
  first: 'Vorname',
  last: 'Nachname',
  manufacturer: 'Hersteller',
  model: 'Modell',
  default: 'Standard',
  registeredOn: 'Angemeldet am',
  lastModifiedOn: 'Zuletzt verändert am',
  createdOn: 'Erstellt am',
  modifiedOn: 'Bearbeitet am',
  cashRegisterName: 'Kassenidentifikationsnummer',
  lines: 'Zeilen',
  collect: 'Einsammeln',
  reportLines: 'Bericht Zeilen',
  balances: 'Kontostände',
  previousSession: 'Vorherige Sitzungssumme',
  currentSession: 'Aktuelle Sitzungssumme',
  previousOrder: 'Vorheriger Auftrag',
  hour: 'Stunde',
  minute: 'Minute',
  beforeDiscount: 'Gesamtsumme vor Rabatt',
  mandatory: 'Pflichtfeld',
  loadingPayments: 'Lade Zahlungen...',
  transactions: 'Transaktionen',
  response: 'Antwort',
  loadingTransactions: 'Lade Transaktionen...',
  notifications: 'Benachrichtigungen',
  text: 'Text',
  themes: 'Themes',
  unpaidOrders: 'Unbezahlte Aufträge',
  numberOfPayments: 'Anzahl von Zahlungen',
  details: 'Details',
  tipAmount: 'Trinkgeld Anzahl',
  dcTaxRate: 'Liefergebühr MwSt.',
  orderId: 'Auftrag ID',
  download: 'Download',
  host: 'Host',
  changedHardware: 'Hardware geändert?',
  swithcCode: 'Tischwechsel Code',
  instance: 'Instanz',
  backendversion: 'Backend Version',
  ipAddress: 'IP Adresse',
  portNumber: 'Port Nummer',
  noUser: 'Kein Benutzer',
  regularInvoices: 'Reguläre Rechnungen',
  cancellationInvoices: 'Storno Rechnungen',
  printers: 'Drucker',
  printJobs: 'PrintJobs',
  changePassword: 'Kennwort ändern',
  dbOptimization: 'DB optimization',
  payment: 'Zahlung',
  system: 'System',
  dataExport: 'Daten Export',
  depReceipts: 'DEP und Belege',
  depAll: 'Alle Logs',
  cashAmount: 'Bar erhalten',
  changeGiven: 'Rückgeld',
  orderType: 'Ordertyp',
  tip: 'Trinkgeld',
  receiptNumber: 'Belegnr.',
  nonTrainingPayedOrders: 'Reguläre bezahlte Bestellungen',
  nonTrainingUnpaidOrders: 'Reguläre unbezahlte Bestellungen',
  nonTrainingServiceCharges: 'Reguläre Servicegebühr',
  trainingPayedOrders: 'Training bezahlte Bestellungen',
  trainingUnpaidOrders: 'Training unbezahlte Bestellungen',
  trainingServiceCharges: 'Training Servicegebühr',
  vatPrint: 'MwSt. Druck',
  monthlyTaxReport: 'Monatlicher Steuerbericht',
  generatedOn: 'Erstellt am',
  regularTotalAmount: 'Regular Gesamtsumme',
  amountOfOrders: 'Bestellungsanzahl',
  amountOfInvoices: 'Rechnungsanzahl',
  cancellationTotalAmount: 'Storno Gesamtsumme',
  detailsPerDay: 'Aufstellung nach Tagen',
  created: 'Erstellt',
  printed: 'Gedruckt',
  prepared: 'Zubereitet',
  inDelivery: 'In Lieferung',
  delivered: 'Geliefert',
  cancelled: 'Abgebrochen',
  notCollected: 'Nicht gesammelt',
  collected: 'Eingesammelt',
  disputed: 'Umstritten',
  regular: 'Regulär',
  cardName: 'Karten Name',
  cardId: 'Karten ID',
  register: 'Anmelden',
  externalId: 'Externe Karten ID',
  walletId: 'Etui ID',
  balance: 'Guthaben',
  cardData: 'Karten Daten',
  getCardBookings: 'Zeige Kartenbuchungen',
  noBookings: 'Keine Kartenbuchungen in dem gewählten Zeitrahmen gefunden.',
  cardBookings: 'Kartenbuchungen',
  amount: 'Betrag',
  expired: 'Abgelaufen',
  bookingId: 'Buchungsnr.',
  bookingType: 'Typ',
  noWallets: 'Kein Etui für diesen Kontakt gefunden.',
  wallets: 'Etuis',
  walletName: 'Etui Name',
  reservedAmount: 'Verfügbarer Betrag',
  walletDetails: 'Etui Details',
  enterGalaxyCard: 'Bitte Galaxy Card eingeben',
  number: 'Nr',
  mode: 'Modus',
  dark: 'Dunkel',
  simpleOrdering: 'Vereinfachte Bestellung',
  fontSizes: 'Schriftgrößen',
  theme: 'Farbe',
  useLastPaymentMethod: 'Letzte Zahlungsmethoden nutzen',
  amountOfPersons: 'Personenanzahl',
  refreshCompanySettings: 'Firmeneinstellungen aktualisieren',
  refreshCatalog: 'Katalog aktualisieren',
  reason: 'Bitte Grund der Deaktivierung eingeben',
  deactivationWarning: 'ACHTUNG: eine deaktivierte Karte ist nicht länger nutzbar. Die Deaktivierung kann nicht rückgängig gemacht werden.',
  none: 'Kein',
  discounts: 'Rabatte',
  clickToRemove: 'Klick auf vorhandenen Rabatt entfernt es',
  moon: '***Moon',
  webshop: '***Webshop',
  mostSoldItem: '***Most sold item count',
  mostCanceledItem: '***Most canceled item count',
  monthYear: '***Month / Year',
  soldCount: 'Verkaufszähler',
  canceledCount: 'Stornozähler',
  moonItemUsageSummary: 'Moon Artikelstatistik',
  webshopItemUsageSummary: 'Webshop Artikelstatistik',
  catalogId: 'Katalog Artikel ID',
  dailyitemusage: 'Täglich',
  monthlyitemusage: 'Monatlich',
  noCancelation: 'Keine Stornodaten.',
  servicecharge: 'Servicegeb',
  deliverycharge: 'Lieferung',
  itemprice: 'Artikel',
  totalSoldAmount: '***Sold amount',
  totalCancelledAmount: '***Cancelled amount',
  byVat: 'Nach Steuersatz',
  byTaxCategory: 'Nach Steuerkategorie',
  byPaymentType: 'Nach Zahlungsmethode',
  total: 'Gesamt',
  selectAddress: 'Adresse wählen',
  quantity: 'Menge',
  comment: 'Anmerkung',
  deliveryCharges: 'Lieferkosten',
  latitude: '***Latitude',
  longitude: '***Longitude',
  price: 'Preis',
  deliveryType: 'Zustellart',
  selectHours: '***Select hours',
  selectMinute: '***Select minutes',
  totalAmount: 'Gesamt',
  deliveryMethod: 'Zustellart',
  change: 'Ändern',
  contactInfo: 'Kontakt Informationen',
  paymentMethod: 'Zahlungsmethode',
  voucher: 'Gutschein',
  time: 'Zeit',
  startTyping: 'Bitte Eingabe starten für Suche',
  asSoon: 'Ehest möglich',
  address: 'Addresse',
  line3AT: 'Stiege/Wohnung/Adressdetails',
  line2AT: 'Hausnummer',
  line1AT: 'Straße',
  chat: 'Chat',
  allergens: 'Allergene',
  showAllergens: 'Allergene anzeigen',
  vatRate: 'MwSt.',
  firstName: 'Vorname',
  lastName: 'Nachname',
  tableName: 'Tischbezeichnung',
  dateTime: 'Datum & Uhrzeit',
  customerTrackingTitle1: 'Erhebung von Kontaktdaten von Gästen in der Gastronomie',
  customerTrackingTitle2: 'gemäß der Verordnung des Magistrats der Stadt Wien betreffend Auskunftserteilung für Contact Tracing im Zusammenhang mit Verdachtsfällen von COVID-19. Die Eintragung erfolgt durch die Kundin/den Kunden:',
  customerDesc: 'Datenschutzrechtliche Information nach Art. 13 DSGVO:\n' +
      'Zweck und Rechtsgrundlagen der Verarbeitung:\n' +
      'Zweck: Contact Tracing zur Verhinderung der (Weiter-)Verbreitung von COVID-19 im Fall des Auftretens eines Verdachtsfalles von COVID-19\n' +
      'Rechtsgrundlagen: Art. 6 Abs. 1 lit. d DSGVO (Verarbeitung personenbezogener Daten zum Schutz lebenswichtiger Interessen der betroffenen Person oder einer anderen natürlichen Person). § 5 Abs. 3 Epidemiegesetz 1950, BGBl. Nr. 186/1950 idF BGBl. I Nr. 103/2020\n' +
      'Verordnung des Magistrats der Stadt Wien betreffend Auskunftserteilung für Contact Tracing im Zusammenhang mit Verdachtsfällen von COVID-19\n' +
      'Verantwortlicher für die Verarbeitung der erhobenen personenbezogenen Daten $partnerCompanyName, $partnerPostalAddress, an die sich die betroffenen Personen zur Wahrnehmung ihrer datenschutzrechtlichen Rechte (z.B. Auskunft, Berichtigung) wenden können.\n\n' +
      'Die verarbeiteten personenbezogenen Daten werden zu folgendem Zweck an folgende Empfänger weitergeleitet:\n' +
      'Zweck: Contact Tracing zur Verhinderung der (Weiter-)Verbreitung von COVID-19 im Fall des Auftretens eines Verdachtsfalles von COVID-19\n' +
      'Empfänger: die Daten sind auf Verlangen der MA 15-Gesundheitsdienst der Stadt Wien an diese weiterzuleiten.\n' +
      'Hinweise\n' +
      'Ihre personenbezogenen Daten werden gem. § 2 der Verordnung des Magistrats der Stadt Wien betreffend Auskunftserteilung für Contact Tracing im Zusammenhang mit Verdachtsfällen von COVID-19 4 Wochen nach ihrer Aufnahme gelöscht.\n' +
      'Betroffenenrechte: Als betroffene Person haben Sie das Recht auf Auskunft über die Sie betreffenden personenbezogenen Daten sowie auf Berichtigung, Löschung oder Einschränkung der Verarbeitung oder auf Widerspruch gegen die Verarbeitung.\n' +
      'Wenn die Verarbeitung auf einer Einwilligung im Sinne des Art. 6 Abs. 1 lit. a oder Art. 9 Abs. 2 lit. a DSGVO beruht, haben Sie das Recht, Ihre Einwilligung jederzeit zu widerrufen. Wir weisen aber darauf hin, dass die Verarbeitung aufgrund der Einwilligung bis zum Widerruf rechtmäßig war.Wenn Sie der Auffassung sind, dass Ihren Rechten nicht oder nicht ausreichend nachgekommen wird, haben Sie die Möglichkeit einer Beschwerde bei der Österreichischen Datenschutzbehörde: Barichgasse 40-42, 1030 Wien, E-Mail: dsb@dsb.gv.at',
  visits: 'Visits',
  delete: 'Delete',
  save: 'Speichern',
  table: 'Tisch',
  deliveryOn: 'Lieferung am',
  ordersSearch: 'Bestellungssuche',
  blacklist: 'Blacklist',
  all: 'Alle',
};



// WEBPACK FOOTER //
// ./src/lang/de/labels.js